import React from 'react';
import { connect } from 'react-redux';
import { CFCProps } from 'types';

const SearchItem: React.FC<Props> = (props) => {
  const { label, item, clickable, customClassName, onItemClick } = props;
  const handleClick = () => {
    if (clickable && typeof onItemClick === 'function') {
      onItemClick(item);
    }
  };
  return (
    <div
      className={`search-item ${
        clickable ? 'search-item--clickable' : ''
      } ${customClassName}`}
      onClick={handleClick}
    >
      <div className="search-item--content">{label}</div>
    </div>
  );
};

SearchItem.displayName = 'SearchItem';

const connector = connect();

type OwnProps = {
  label: string;
  item: any;
  clickable: boolean;
  customClassName?: string;
  onItemClick?: Function;
};

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(SearchItem));
